import { RestUrl } from "../common/cyan.types";

export class DocumentSignerUrl {
  public static getDocumentSignBySignerToken: (token: string) => RestUrl = token => ["GET", `/document-signs/token/${token}`];
  /** 서명용 이메일 인증코드 발송 요청 */
  public static requestEmailVerificationCodeBySignerToken: (token: string) => RestUrl = token => [
    "POST",
    `/document-signs/token/${token}/email-verify`,
  ];
  public static downloadCertificateBySignerToken: (token: string) => RestUrl = token => [
    "POST",
    `/document-signs/token/${token}/certificate/download`,
  ];
  public static getDocumentSignDocsPdfPage: (token: string) => RestUrl = token => ["GET", `/document-sign/docs-pdf/page/token/${token}`];
  public static signDocumentWithSignerToken: RestUrl = ["POST", "/document-signer/sign"];
  public static declineDocumentWithSignerToken: RestUrl = ["POST", "/document-signer/decline"];
  public static remindDocumentSignerSign: (documentSignerId: bigint) => RestUrl = documentSignerId => [
    "POST",
    `/document-signer/signers/${documentSignerId}/remind-sign`,
  ];
  public static createDocumentSigns: RestUrl = ["POST", "/document-signer/signs"];
}
